import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class PlanningDashboardOverviewIndexRoute extends Route {
  @service router;

  beforeModel() {
    return this.router.transitionTo('planning.dashboard.overview.grid');
  }
}

export default instrumentRoutePerformance(PlanningDashboardOverviewIndexRoute);
